module.exports = __webpack_public_path__ + "img/macro05.65709dd4.png";